import React from 'react';

const Badge = ({ children, variant = 'primary', size = 'md' }) => {
  const variants = {
    primary: { bg: '#DBEAFE', color: '#1E40AF' },
    success: { bg: '#D1FAE5', color: '#065F46' },
    warning: { bg: '#FEF3C7', color: '#92400E' },
    danger: { bg: '#FEE2E2', color: '#991B1B' },
    info: { bg: '#E0E7FF', color: '#3730A3' },
    default: { bg: '#F1F5F9', color: '#475569' },
  };

  const sizes = {
    sm: { padding: '4px 10px', fontSize: '11px' },
    md: { padding: '6px 14px', fontSize: '12px' },
    lg: { padding: '8px 16px', fontSize: '13px' },
  };

  return (
    <>
      <style>{`
       .badge {
          display: inline-block;
          border-radius: 20px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          transition: all 0.3s ease;
        }
       .badge:hover {
          transform: scale(1.05);
        }
      `}</style>
      <span 
        className="badge" 
        style={{ 
          background: variants[variant].bg, 
          color: variants[variant].color,
         ...sizes[size]
        }}
      >
        {children}
      </span>
    </>
  );
};

export default Badge;